import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  FormControlLabel,
  Grid2,
  IconButton,
  Switch,
  Button,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MaterialSelect";
import colors from "../../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import MessagePopup from "../../../Utils/MessagePopup";
import ConfirmDialog from "../../../Utils/ConfirmDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import axiosInstance, { API_URL } from "../../../Utils/url";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import { useLoading } from "../../../../context/loadingcontext";

const Addwallet = ({ formClose, formType, setOpen, rowId }) => {
  //   const { isuser } = useContext(UserContext);

  const [insurerdata, setinsurerdata] = useState({
    insurer: "",
    companyname: "",
    walletamount: "",
    transactionNo: "",
    insurerStatus: "unchecked",
    companynameStatus: "unchecked",
    walletamountStatus: "unchecked",
    transactionNoStatus: "unchecked",
  });

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [compneyNameOptions, setCompneyNameOptions] = useState([]);
  const [insurenceNameOptions, setInsurenceNameOptions] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);

  const [inputStatus, setinputStatus] = useState(false);

  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();

  useEffect(() => {
    fetchInsurenceName();
  }, []);

  useEffect(() => {
    if (formType == "view") {
      setinputStatus(true);
    } else {
      setinputStatus(false);
    }
    fetchWalletById();
  }, [formType]);

  const fetchWalletById = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/wallet-configuration/${rowId}/`
      );
      const success = response?.data?.success;
      const data = response?.data?.data;
      setinsurerdata({
        insurer: { value: data?.insurance_name, label: data?.insurance_name },
        companyname: { value: data?.company_name, label: data?.company },
        walletamount: data?.wallet_amount,
        transactionNo: data?.transaction_no,
        insurerStatus: "success",
        companynameStatus: "success",
        walletamountStatus: "success",
        transactionNoStatus: "success",
      });
    } catch (err) {
    } finally {
    }
  };
  const fetchInsurenceName = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}v1/insurance-name/`);

      setInsurenceNameOptions(response?.data?.data);
    } catch (error) {
      setInsurenceNameOptions([]);
    }
  };
  const fetchCompneyName = async (id) => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/company-name/${id}/`
      );

      setCompneyNameOptions(response?.data?.data);
    } catch (error) {
      setCompneyNameOptions([]);
    }
  };
  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...insurerdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "insurer") {
        fetchCompneyName(event?.value);
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "companyname") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "transactionNo":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "walletamount":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setinsurerdata(formState);
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setinsurerdata({
      ...insurerdata,
      companyname: "",
      walletamount: "",
      transactionNo: "",
      companynameStatus: "unchecked",
      walletamountStatus: "unchecked",
      transactionNoStatus: "unchecked",
    });
    formClose();
  };

  const isFormValid = () => {
    return insurerdata.companynameStatus == "success";
  };

  const hanldeConfirmDialogSubmit = async () => {
    setDialogOpen(false);
    setCirleLoading(true);

    try {
      const data = {
        company_name: insurerdata?.companyname?.value,
        wallet_amount: insurerdata?.walletamount,
        transaction_no: insurerdata?.transactionNo,
      };

      const response =
        formType == "edit"
          ? await axiosInstance.put(
              `${API_URL}v1/wallet-configuration/${rowId}/`,
              data
            )
          : await axiosInstance.post(
              `${API_URL}v1/wallet-configuration/`,
              data
            );
      setOpen(false);
      showSnackbar(response?.data?.message, "success");
    } catch (err) {
      showSnackbar(err?.response?.data?.message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        {/* <Loader isLoading={isLoading} /> */}
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              New Wallet
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5}>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Insurance name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="insurer"
              placeholder={`Select Client`}
              value={insurerdata.insurer}
              options={insurenceNameOptions?.map((v) => ({
                value: v?.id,
                label: v?.insurance_name,
              }))}
              searchable={false}
              onChange={handleAddCourseChange}
              error={insurerdata.insurerStatus === "error" ? true : false}
              success={insurerdata.insurerStatus === "success" ? true : false}
              isDisabled={inputStatus}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Company name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="companyname"
              placeholder={`Select Company`}
              value={insurerdata.companyname}
              options={compneyNameOptions?.map((v) => ({
                value: v?.id,
                label: v.company_name,
              }))}
              searchable={false}
              onChange={handleAddCourseChange}
              error={insurerdata.companynameStatus === "error" ? true : false}
              success={
                insurerdata.companynameStatus === "success" ? true : false
              }
              isDisabled={inputStatus}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Wallet Amount
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="walletamount"
              placeholder="Enter Wallet Amount"
              value={insurerdata.walletamount}
              onChange={handleAddCourseChange}
              error={insurerdata.walletamountStatus === "error" ? true : false}
              success={
                insurerdata.walletamountStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.walletamountStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Wallet amount must be in number and should not exceed
                combination of 15 digits.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Transaction No
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="transactionNo"
              placeholder="Enter Transaction No"
              value={insurerdata.transactionNo}
              onChange={handleAddCourseChange}
              error={insurerdata.transactionNoStatus === "error" ? true : false}
              success={
                insurerdata.transactionNoStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.transactionNoStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Transaction No must be 1 to 50 Alpha numeric characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {inputStatus == false && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  Submit
                </MaterialButton>
              )}
              <MaterialButton
                onClick={reset}
                variant="outlined"
                sx={{
                  color: colors.cancel,
                  borderColor: colors.cancel,
                  "&:hover": {
                    borderColor: colors.cancel,
                  },
                }}
              >
                Cancel
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default Addwallet;
